import React from "react";
import {
  Box,
} from "@mui/material";
import ContentHeader from "../ContentHeader/ContentHeader";
import LoanCardCarousel from "../carouselComponent/loanCardCarouselComponent";

const loanAmounts = [
  "₹50,000",
  "₹100,000",
  "₹150,000",
  "₹200,000",
  "₹250,000",
  "₹300,000",
  "₹350,000",
  "₹400,000",
  "₹450,000",
  "₹500,000"
];

const BudgetCarouselSection = () => {

  return (
    <Box sx={{ p: { xs: 2, md: 8 }, backgroundColor: { xs: "#fff", md: "#F1FFF0" } }}>
      <ContentHeader
        heading={"Personal loan for different budgets."}
        paragraph={"Explore personal loan options based on the amount you need."}
      />

      <LoanCardCarousel amounts={loanAmounts}/>
        
    </Box>
  );
};

export default BudgetCarouselSection;
